import React from 'react';
import { NavLink, useParams, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const StoreSettingsLayout = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const permissions = user?.permissions || [];
  const canCreateStore = permissions.includes('stores:create');
  const canUpdateStore = permissions.includes('stores:update');
  const isNew = id === 'new';
  const isAuthorized = isNew ? canCreateStore : canUpdateStore;

  if (!isAuthorized) {
    return (
      <div className="p-6 bg-gray-100 min-h-screen">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <p className="text-red-600 font-medium">Access denied: you do not have permission to modify store settings.</p>
          <button
            type="button"
            onClick={() => navigate('/stores')}
            className="mt-4 bg-gray-300 text-gray-800 px-4 py-2 rounded-md"
          >
            Back to Store List
          </button>
        </div>
      </div>
    );
  }

  const NavItem = ({ to, children }) => (
    <NavLink
      to={`/stores/settings/${id}/${to}`}
      end // This prop is important to prevent parent routes from staying active
      className={({ isActive }) =>
        `block px-4 py-2 text-sm rounded-md ${isActive ? 'bg-blue-100 text-blue-700 font-semibold' : 'text-gray-600 hover:bg-gray-100'}`
      }
    >
      {children}
    </NavLink>
  );

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-800">Store Settings</h1>
        <div>
          <button onClick={() => navigate('/stores')} className="bg-gray-300 text-gray-800 px-4 py-2 rounded-md">Back to Store List</button>
        </div>
      </div>
      <div className="flex flex-col lg:flex-row lg:space-x-6">
        <aside className="lg:w-1/5 mb-6 lg:mb-0">
          <div className="bg-white p-4 rounded-lg shadow-md space-y-1">
            <NavItem to="basic">Basic Information</NavItem>
            <NavItem to="location">Location</NavItem>
            <NavItem to="payments">Payments</NavItem>
            <NavItem to="timing">Time Setting</NavItem>
            <NavItem to="printing">Printing</NavItem>
            <NavItem to="ordering">Ordering Setting</NavItem>
            <NavItem to="devices">Devices</NavItem>
            <NavItem to="tyro">Tyro</NavItem>
            <NavItem to="tyro-reports">Tyro Reports</NavItem>
          </div>
        </aside>
        <main className="lg:w-4/5">
          <div className="bg-white p-6 rounded-lg shadow-md">
            {/* The Outlet renders the specific settings component (e.g., BasicInfoSettings) */}
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default StoreSettingsLayout;
